export const deleteAssign = (payload: any) => ({
    type: "@saga/DELETE_ASSIGN",
    payload
});